import React, { useState, useEffect } from 'react';

interface ProgressiveImageProps {
  src: string;
  alt: string;
  priority?: boolean;
}

const ProgressiveImage: React.FC<ProgressiveImageProps> = ({ src, alt, priority }) => {
  const webpSrc = src.replace(/\.(png|jpg|jpeg)$/i, '.webp');
  
  return (
    <div className="progressive-image-container">
      <picture>
        <source srcSet={webpSrc} type="image/webp" />
        <img 
          src={src} 
          alt={alt}
          loading={priority ? "eager" : "lazy"}
        />
      </picture>
    </div>
  );
};

export default ProgressiveImage; 